/**
 * Participants and caregivers share one sign-in (FECOA-2156). The ID typed on
 * it says who is signing in: every Caregiver ID starts with CG- (the API
 * numbers each sponsor's caregivers CG-00001 upwards), while a participant
 * signs in with their participant number, which is digits only.
 */

/** Longest Caregiver ID the API stores. */
export const CAREGIVER_ID_MAX_LENGTH = 20;

// CG, then an optional dash or space, then the number.
const CAREGIVER_ID = /^CG[\s-]?(\d+)$/;

/** True while the text is on its way to being a Caregiver ID. */
export const looksLikeCaregiverId = (value) => /^\s*C/i.test(String(value ?? ''));

/**
 * The ID field's text as typed: digits for a participant number, as the field
 * always allowed, or the letters, digits, spaces and dash of a Caregiver ID.
 */
export const cleanSignInIdInput = (value) => {
  const text = String(value ?? '');
  if (!looksLikeCaregiverId(text)) return text.replace(/\D/g, '');
  return text
    .toUpperCase()
    .replace(/[^A-Z0-9 -]/g, '')
    .slice(0, CAREGIVER_ID_MAX_LENGTH);
};

/**
 * The Caregiver ID in the form the API expects ("CG-00001"), or null when the
 * text is not a whole Caregiver ID.
 */
export const parseCaregiverId = (value) => {
  const match = CAREGIVER_ID.exec(String(value ?? '').trim().toUpperCase());
  if (!match) return null;
  const id = `CG-${match[1]}`;
  return id.length <= CAREGIVER_ID_MAX_LENGTH ? id : null;
};
